import React from 'react';
import SignupContainer from 'views/SignupContainer';
import AdminInfoForm from 'shared/components/Forms/AdminInfoForm';

const AdminInfo = () => {
  return (
    <SignupContainer>
      <AdminInfoForm />
    </SignupContainer>
  );
};

export default AdminInfo;
